import { Link } from "react-router-dom";
import { FaSearch, FaShoppingCart } from "react-icons/fa";

const EmptyCartState = () => (
  <div className="text-center py-16 max-w-md mx-auto">
    <div className="w-20 h-20 rounded-full bg-surface-low shadow-sm flex items-center justify-center mx-auto mb-6">
      <FaShoppingCart className="text-primary text-3xl" />
    </div>
    <h2 className="text-xl font-bold text-on-primary-fixed-var mb-2">Your cart is empty</h2>
    <p className="text-sm text-on-surface-variant mb-8 leading-relaxed">
      You haven&apos;t added any wellness tests or packages to your cart yet.
    </p>
    <Link
      to="/lab-tests"
      className="inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-3 rounded-xl font-semibold text-sm hover:bg-primary-container transition-colors mb-4"
    >
      <FaSearch size={14} />
      Browse Lab Tests
    </Link>
    <div>
      <Link to="/mybookings" className="text-primary font-semibold text-sm hover:underline">
        View Past Orders
      </Link>
    </div>
  </div>
);

export default EmptyCartState;
